import { FunctionComponent, useState } from "react"
import { useRouter } from "next/router"

import CarSectionCar from "@/components/CarSectionCar/CarSectionCar"
import Button from "@/components/forms/Button/Button"
import { ICarsFields } from "@/types/contentful"
import Toggle from "@/components/forms/Toggle/Toggle"
import LocationForm from "@/components/forms/LocationForm/LocationForm"
import HourseStep from "@/components/forms/HoursStep/HoursStep"
import Arrow from "@/assets/icons/arrow.svg"

import styles from "./styles.module.scss"
import Link from "next/link"

interface LocationStepProps {
  car: ICarsFields
}

const LocationStep: FunctionComponent<LocationStepProps> = ({ car }) => {
  const router = useRouter()

  const [active, setActive] = useState(true)

  return (
    <div>
      <div className={styles.form__wrapper}>
        <div className={styles.form__choice}>
          <h2 className={styles.form__title}>Your choiсe</h2>
          <CarSectionCar {...car} count={1} />
          <Link
            href={{
              pathname: "/cars",
              query: {
                firstname: router.query.firstname,
                lastname: router.query.lastname,
                phone: router.query.phone,
                email: router.query.email,
                passengers: router.query.passengers,
                flightNumber: router.query.flightNumber,
              },
            }}
            passHref
            legacyBehavior
          >
            <Button
              asType="secondary"
              leftIcon={<Arrow />}
              className={styles.form__back_button}
            >
              Change the car
            </Button>
          </Link>
        </div>
        <div className={styles.form__container}>
          <div className={styles.form}>
            <Toggle
              isFirstActive={active}
              onToggle={setActive}
              className={styles.form__toggle}
            />
            {active && <LocationForm nextStepUrl="/order/details" />}
            {!active && <HourseStep nextStepUrl="/order/details" />}
          </div>
        </div>
      </div>
    </div>
  )
}

export default LocationStep
